module.exports = __webpack_public_path__ + "static/carlos-1a0d24d95ec3d9dabcf86701a00a7192.jpg";